import { ApplicationError } from "@rocicorp/zero";
import * as Sentry from "@sentry/react";

// Demote Zero's error logs to warn to keep transient sync chatter out of
// Sentry, but tee unexpected mutator throws through — `userFacing`-tagged
// errors are expected validation/auth failures, the rest are real bugs.
export const zeroLogger = {
  logLevel: "error" as const,
  logSink: {
    log: (
      level: "error" | "warn" | "info" | "debug",
      context: Record<string, unknown> | undefined,
      ...args: unknown[]
    ) => {
      if (level === "error") {
        const appError = args.find(
          (a): a is ApplicationError => a instanceof ApplicationError
        );
        if (
          appError &&
          (appError.details as { userFacing?: boolean } | undefined)
            ?.userFacing !== true
        ) {
          Sentry.captureException(appError, {
            tags: { source: "zero-mutator" },
            extra: { zeroContext: context, message: args[0] },
          });
        }
      }
      console.warn(level, context, ...args);
    },
  },
};
